module.exports = __webpack_public_path__ + "img/sinExc.03283fc1.svg";